import React, { useEffect, useState } from 'react';
import Forecast from '../components/overview/Forecast';
import { httpGetWaveForecastByStationId, 
      httpGetWaterLevelByStationId,
      httpGetWeatherNowByLocationId,
      httpGetWeatherByLocationId } from "../hooks/forecast/api";
import { httpGetSpotById } from "../hooks/spot/api";
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

export default function ForecastPage() {

  const [forecast, setForecast] = useState([]);
  const [waterLevel, setWaterLevel] = useState([]);
  const [weatherNow, setWeatherNow] = useState([]);
  const [weatherWeek, setWeatherWeek] = useState([]);
  const [spotWaveConditions, setSpotWaveConditions] = useState([]);
  const [waveStationForecast, setWaveStationForecast] = useState("");
  const [waveStationRealTime, setWaveStationRealTime] = useState("");
  
  //const sleep = ms => new Promise(r => setTimeout(r, ms));

  const loadData = () => {
   
    // TO-DO: get favorite spot to identify the params below
    const SPOT_ID = 1;    // TO-DO: remove hardcode and add logic to identify nearest user buoy
    const NEARBY_STATION = '46222';    // TO-DO: remove hardcode and add logic to identify buoy of favorite spot
    const tideStationId = '9410230'     // TO-DO: remove hardcode and add logic to identify tide station of favorite spot
    const locationId = '1'      // TO-DO: remove hardcode and add logic to identify location based on favorite spot

    // real time wave summary (Nooa latest reading)
    httpGetWaveForecastByStationId(NEARBY_STATION).then( 
        async (result) => { 
          //await sleep(10000)
          setForecast(result);
    })

    // get tide info
    httpGetWaterLevelByStationId(tideStationId).then( 
      (result) => { 
        setWaterLevel(result);
    })

    // today's weather
    httpGetWeatherNowByLocationId(locationId).then( 
      (result) => { 
        setWeatherNow(result);
        
    })

    // week's weather
    httpGetWeatherByLocationId(locationId).then( 
      (result) => { 
        setWeatherWeek(result);
    })

    // wave forecast
    httpGetSpotById(SPOT_ID).then( 
      (result) => { 
      setWaveStationForecast(result.noaa_station_id_forecast)
      setWaveStationRealTime(result.noaa_station_id_realtime)
      setSpotWaveConditions(result)
    })

  }

  useEffect(() => {
      loadData();
  }, []);

  const landingPage = () => {
        return <Forecast 
                waveStationForecast={waveStationForecast}
                waveStationRealTime={waveStationRealTime}
                forecast={forecast} 
                waterLevel={waterLevel} 
                weather={weatherNow} 
                spotWaveConditions={spotWaveConditions}
                weatherWeek={weatherWeek}
                />
  }

    return (
     forecast.length>0 ? (
      <div>
        { landingPage() } 
      </div>
      ) : (
        <Box sx={{ width: '100%', alignContent: 'center', padding: '20px' }}>
            <Stack spacing={3}>
              <Skeleton variant="rectangular" width="100%"  height={120}/> 
              <Skeleton variant="rectangular" width="100%"  height={200}/> 
              <Skeleton variant="rectangular" width="100%"  height={80}/> 
              <Skeleton variant="rectangular" width="100%"  height={200}/> 
              <Skeleton variant="rectangular" width="100%"  height={200}/> 
              <Skeleton variant="rectangular" width="100%"  height={200}/> 
              <Skeleton variant="rectangular" width="100%"  height={200}/> 
              <Skeleton variant="rectangular" width="100%"  height={200}/> 
              <Skeleton variant="rectangular" width="100%"  height={200}/> 
            </Stack>
          </Box>
      )
  ) 

}
